import type { useGetInsurancePayers } from '../../../../../../hooks/api-hooks';

type Payer = ReturnType<typeof useGetInsurancePayers>['payers'][number];

export type PayerOption = { id: string; name: string };

export const OTHER_OPTION_VALUE = 'other';

const SEPARATOR = '\x00';

export const makeOptionKey = (id: string, name: string) => `${id}${SEPARATOR}${name}`;

export const parseOptionKey = (key: string): { id: string; name: string } => {
  const idx = key.indexOf(SEPARATOR);
  return { id: key.slice(0, idx), name: key.slice(idx + 1) };
};

export const filterPayers = (payers: Payer[], searchValue: string): PayerOption[] => {
  if (!searchValue) return payers.map((p) => ({ id: p.id ?? '', name: p.name ?? '' }));
  const lower = searchValue.toLowerCase();
  const startsWith: PayerOption[] = [];
  const contains: PayerOption[] = [];
  for (const p of payers) {
    const name = (p.name ?? '').toLowerCase();
    if (name.startsWith(lower)) {
      startsWith.push({ id: p.id ?? '', name: p.name ?? '' });
    } else if (name.includes(lower)) {
      contains.push({ id: p.id ?? '', name: p.name ?? '' });
    }
  }
  return [...startsWith, ...contains];
};

export const buildOptions = (filteredPayers: PayerOption[], searchValue: string, otherLabel: string): PayerOption[] => {
  const showOther = !searchValue || filteredPayers.length === 0 || 'other'.includes(searchValue.toLowerCase());
  return showOther ? [...filteredPayers, { id: OTHER_OPTION_VALUE, name: otherLabel }] : filteredPayers;
};
